import { handleValidationChange } from "../CommonValidations/CommonValidaions";

export const validatePhilhealthFormData = (data, setError) => {
  let isDataValid = true;

  // patient_type: "member" | "dependent"
  if (data.patient_type !== "member" && data.patient_type !== "dependent") {
    handleValidationChange("patient_type", true, setError);
    isDataValid = false;
  } else {
    handleValidationChange("patient_type", false, setError);
  }

  // member_pin: string
  if (data.member_pin === "") {
    handleValidationChange("member_pin", true, setError);
    isDataValid = false;
  } else {
    handleValidationChange("member_pin", false, setError);
  }

  // dependent_pin?: string (12 characters) if patient_type is "dependent"
  if (data.patient_type === "dependent" && data.dependent_pin === "") {
    handleValidationChange("dependent_pin", true, setError);
    isDataValid = false;
  } else {
    handleValidationChange("dependent_pin", false, setError);
  }

  // first_name: string
  if (data.first_name === "") {
    handleValidationChange("first_name", true, setError);
    isDataValid = false;
  } else {
    handleValidationChange("first_name", false, setError);
  }

  // last_name: string
  if (data.last_name === "") {
    handleValidationChange("last_name", true, setError);
    isDataValid = false;
  } else {
    handleValidationChange("last_name", false, setError);
  }

  // birthdate: string
  if (data.birthdate === "") {
    handleValidationChange("birthdate", true, setError);
    isDataValid = false;
  } else {
    handleValidationChange("birthdate", false, setError);
  }

  // mobile_number: string (11 characters)
  // if (data.mobile_number === "" || data.mobile_number.length !== 11) {
  //   handleValidationChange("mobile_number", true, setError);
  //   isDataValid = false;
  // } else {
  //   handleValidationChange("mobile_number", false, setError);
  // }

  // enlistment_date: string
  if (data.enlistment_date === "") {
    handleValidationChange("enlistment_date", true, setError);
    isDataValid = false;
  } else {
    handleValidationChange("enlistment_date", false, setError);
  }

  // enlistment_status: "active" | "cancelled" | "transferred"
  if (
    data.enlistment_status !== "active" &&
    data.enlistment_status !== "cancelled" &&
    data.enlistment_status !== "transferred"
  ) {
    handleValidationChange("enlistment_status", true, setError);
    isDataValid = false;
  } else {
    handleValidationChange("enlistment_status", false, setError);
  }

  // package_type: "Konsulta Package" | "PCB1" | "Expanded PCB"
  if (
    data.package_type !== "Konsulta Package" &&
    data.package_type !== "PCB1" &&
    data.package_type !== "Expanded PCB"
  ) {
    handleValidationChange("package_type", true, setError);
    isDataValid = false;
  } else {
    handleValidationChange("package_type", false, setError);
  }

  // atc: string
  if (data.atc === "") {
    handleValidationChange("atc", true, setError);
    isDataValid = false;
  } else {
    handleValidationChange("atc", false, setError);
  }

  return isDataValid;
};
